<template>
  <div>
    <div class="alert alert-danger" role="alert" v-for="(group, index) in getErrors(fields)" :key="group[index]">
      <a v-if="!group.important"
        href="#"
        class="close"
        data-dismiss="alert"
        @click.prevent.stop="clearError([group.name])">
        &times;
      </a>

      <p v-if="group.name === 'UnprocessableEntity'">
        Foram encontrados alguns erros no formulário, por favor, revise-o e tente novamente.
      </p>

      <!-- <ul>
        <li v-for="(messages, msgIndex) in group.data.errors" :key="messages[msgIndex]">
          <span v-for="(message, index) in messages" :key="message[index]">
            {{ message }}
          </span>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    props: {
      fields: {
        type: Array,
        default () { return [] }
      }
    },

    computed: {
      ...mapState('errors', {
        errors: state => state.all
      }),

      ...mapGetters({
        'getErrors': 'errors/getErrors'
      })
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/Flash.vue